import { Navigate } from 'react-router';
import { useAuthStore } from '@/features/auth/stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
  requiredPermissions?: string[];
}

export const ProtectedRoute = ({
  children,
  requiredRoles,
  requiredPermissions,
}: ProtectedRouteProps) => {
  const { isAuthenticated, user, hasAnyPermission } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && user) {
    const hasRole = requiredRoles.some((role) =>
      user.roles?.some((r) => r.toLowerCase() === role.toLowerCase()) ?? false
    );
    if (!hasRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  if (requiredPermissions && requiredPermissions.length > 0) {
    if (!hasAnyPermission(requiredPermissions)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
};